// extracted by mini-css-extract-plugin
export default {"answer":"G8-z","bestAnswerHeading":"H8-z","meta":"I8-z"};